var _rect, _rect2, _rect3, _rect4, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindowInside(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "411px",
    height: "571px",
    viewBox: "0 0 411 571",
    enableBackground: "new 0 0 411 571",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.5,
    fill: "#EDEDED",
    width: 411,
    height: 572
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 31.9,
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeWidth: 3.538,
    strokeMiterlimit: 10,
    width: 346.1,
    height: 484.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6,
    y: 58.5,
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeWidth: 2.4414,
    strokeMiterlimit: 10,
    width: 297.6,
    height: 431
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.6,
    y: 73.6,
    fill: "none",
    stroke: "#878787",
    strokeWidth: 2.4414,
    strokeMiterlimit: 10,
    width: 267.6,
    height: 400.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.6,
    y: 61.8,
    fill: "#B2B2B2",
    width: 297.6,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6,
    y: 61.8,
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.776,
    strokeMiterlimit: 10,
    width: 297.6,
    height: 7.6
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M63.5,72.7V479h0.2 c1.3,3.1,8.6,5.6,17.5,5.6s16.2-2.4,17.5-5.6h0.2V72.7H63.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M63.5,102.5c0,0,14.1,6.9,35.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M99,72.7V479h0.2 c1.3,3.1,8.6,5.6,17.5,5.6s16.2-2.4,17.5-5.6h0.2V72.7H99z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M99,102.5c0,0,14.1,6.9,35.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M134.4,72.7V479h0.2 c1.3,3.1,8.6,5.6,17.5,5.6c8.9,0,16.2-2.4,17.5-5.6h0.2V72.7H134.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M134.4,102.5c0,0,14.1,6.9,35.4,0"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M170.1,72.7V479h0.2 c1.3,3.1,8.6,5.6,17.5,5.6c8.9,0,16.2-2.4,17.5-5.6h0.2V72.7H170.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M170.1,102.5c0,0,14.1,6.9,35.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M205.6,72.7V479h0.2 c1.3,3.1,8.6,5.6,17.5,5.6c8.9,0,16.2-2.4,17.5-5.6h0.2V72.7H205.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M205.6,102.5c0,0,14.1,6.9,35.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M240.9,72.7V479h0.2 c1.3,3.1,8.6,5.6,17.5,5.6c8.9,0,16.2-2.4,17.5-5.6h0.2V72.7H240.9z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M240.9,102.5c0,0,14.1,6.9,35.4,0"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M276.6,72.7V479h0.2 c1.3,3.1,8.6,5.6,17.5,5.6c8.9,0,16.2-2.4,17.5-5.6h0.2V72.7H276.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M276.6,102.5c0,0,14.1,6.9,35.4,0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M312.1,72.7V479h0.2 c1.3,3.1,8.6,5.6,17.5,5.6c8.9,0,16.2-2.4,17.5-5.6h0.2V72.7H312.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 1.0333,
    strokeMiterlimit: 10,
    d: "M312.1,102.5c0,0,14.1,6.9,35.4,0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowInside);
export default __webpack_public_path__ + "static/media/window-Inside.211f9934fc926b14ba8e8e28ed4bc2b8.svg";
export { ForwardRef as ReactComponent };